import { render, staticRenderFns } from "./table-header.vue?vue&type=template&id=7c7e9c10&scoped=true&"
import script from "./table-header.ts?vue&type=script&lang=ts&"
export * from "./table-header.ts?vue&type=script&lang=ts&"
import style0 from "./table-header.scss?vue&type=style&index=0&id=7c7e9c10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c7e9c10",
  null
  
)

export default component.exports